export default __webpack_public_path__ + "static/media/img_about_pintar.e625f6ab.webp";